// src/library/userModuleRegistry.ts

import type { UserPresetTemplate } from "@/types/userPresetTemplate";
import type { UserComponentJson } from "@/types/userComponent";
import { useMoudleStore } from "@/stores/module";
import { createUserComponentCreator } from "./modules/userTemplateCreator";



const PRESET_KEY = "flui3d-user-module-templates";

export function loadUserModuleTemplates(): UserPresetTemplate[] {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(PRESET_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw) as UserPresetTemplate[];
  } catch (e) {
    console.warn("Failed to parse user module templates:", e);
    return [];
  }
}

export function saveUserModuleTemplates(templates: UserPresetTemplate[]) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(PRESET_KEY, JSON.stringify(templates));
}

export function addUserModuleTemplate(template: UserPresetTemplate) {
  const list = loadUserModuleTemplates();
  list.push(template);
  saveUserModuleTemplates(list);
}


export function deleteUserModuleTemplate(id: string) {
  const list = loadUserModuleTemplates();
  const next = list.filter((t) => t.id !== id);
  saveUserModuleTemplates(next);
}

export function renameUserModuleTemplate(id: string, newName: string) {
  const list = loadUserModuleTemplates();
  const idx = list.findIndex((t) => t.id === id);
  if (idx === -1) return;
  list[idx] = { ...list[idx], name: newName };
  saveUserModuleTemplates(list);
}



const COMPONENT_KEY = "flui3d-user-components";

export function loadUserComponents(): UserComponentJson[] {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(COMPONENT_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw) as UserComponentJson[];
  } catch (e) {
    console.warn("Failed to parse user components:", e);
    return [];
  }
}

export function saveUserComponents(components: UserComponentJson[]) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(COMPONENT_KEY, JSON.stringify(components));
}


export function registerUserComponent(component: UserComponentJson) {
  
  const list = loadUserComponents();
  const idx = list.findIndex((c) => c.name === component.name);
  if (idx >= 0) {
    list[idx] = component;
  } else {
    list.push(component);
  }
  saveUserComponents(list);

  
  const moduleStore = useMoudleStore();
  // Let the store initialize pendingModule after the creator has become
  // reactive. Otherwise the newly imported card may not render until reload.
  const creator = createUserComponentCreator(component, false);
  if (typeof moduleStore.addUserCreator === "function") {
    moduleStore.addUserCreator(creator);
  } else {
    console.warn(
      "[userModuleRegistry] moduleStore.addUserCreator is not defined. Please add it in useMoudleStore."
    );
  }
}


export function restoreAllUserComponents() {
  const moduleStore = useMoudleStore();
  const list = loadUserComponents();
  list.forEach((component) => {
    const creator = createUserComponentCreator(component, false);
    if (typeof moduleStore.addUserCreator === "function") {
      moduleStore.addUserCreator(creator);
    }
  });
}


export function deleteUserComponent(name: string) {
  const list = loadUserComponents();
  const next = list.filter((c) => c.name !== name);
  saveUserComponents(next);

 
}


export function renameUserComponent(oldName: string, newName: string) {
  const list = loadUserComponents();
  const idx = list.findIndex((c) => c.name === oldName);
  if (idx === -1) return;

  list[idx] = { ...list[idx], name: newName };
  saveUserComponents(list);


}


